var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"academy-course-container"},[_c('v-breadcrumbs',{attrs:{"options":[
      { label: 'Eyecare Academy', onClick: () => this.$router.push('/academy') },
      { label: _vm.course ? _vm.course.name : '' },
    ]}}),_c('div',{staticClass:"content"},[_c('v-video-menu',{attrs:{"course":_vm.course,"progress":_vm.progress},on:{"selectVideoClass":_vm.selectVideoClass}}),_c('v-video-content',{attrs:{"user":_vm.user,"course":_vm.course,"progress":_vm.progress,"goTo":_vm.goTo}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }